module.exports = require('./core_factory')



/** WEBPACK FOOTER **
 ** ./src/components/core_factory/index.js
 **/